module.exports = __webpack_public_path__ + "img/10.9801848a.jpeg";